/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：519
 */

var r = require(/* 2383 */"./2383/index")
var i = require(/* 2384 */"./2384")
var o = i
o.v1 = r
o.v4 = i
module.exports = o
